import instance from "./instance";
export const findOne = (language) => {
    return instance.get(`/translations/${language}`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
